import { fmtDay } from '../../utils/format.js';

// The role people are told, suggested from what the supplier does
export const ROLE_SUGGESTIONS = {
  housing_bureau: 'Official housing bureau',
  directory_publisher: 'Official event directory',
  stand_builder: 'Official stand contractor',
  av: 'Official AV supplier',
  freight: 'Official freight forwarder',
  catering: 'Official caterer',
  registration: 'Official registration partner',
  venue: 'Venue',
  marketing: 'Official agency',
  other: 'Official supplier',
};

/** "Official housing bureau — Demo Expo 2027, from 1 Jan 2030" */
export function appointmentText(a) {
  const where = a.covers.type === 'company' ? 'every event' : a.covers.type === 'brand' ? `${a.covers.name} (brand)` : a.covers.name;
  const dates = a.valid_from || a.valid_until
    ? `, ${a.valid_from ? `from ${fmtDay(a.valid_from)}` : ''}${a.valid_from && a.valid_until ? ' ' : ''}${a.valid_until ? `until ${fmtDay(a.valid_until)}` : ''}`
    : '';
  return `${a.role_label} — ${where}${dates}`;
}
